import { render, staticRenderFns } from "./hotelRealtimeOrder.vue?vue&type=template&id=1dbad710&scoped=true&"
import script from "./hotelRealtimeOrder.vue?vue&type=script&lang=js&"
export * from "./hotelRealtimeOrder.vue?vue&type=script&lang=js&"
import style0 from "./hotelRealtimeOrder.vue?vue&type=style&index=0&id=1dbad710&prod&scoped=true&lang=css&"
import style1 from "./hotelRealtimeOrder.vue?vue&type=style&index=1&id=1dbad710&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbad710",
  null
  
)

export default component.exports